import React, { FC } from 'react'
import { func, string } from 'prop-types'
import styled from 'styled-components'
import { SwapStyle } from '../Themes'

const _PoolButton = styled.button`
  color: ${({ theme }) => theme.poolPanelButtonTextColor};
  background-color: ${({ theme }) => theme.poolPanelButtonBackgroundColor};

  border: none;
  // border: 1px solid ${({ theme }) => theme.poolPanelButtonBorderColor};
  box-shadow: ${({ theme }) => theme.poolPanelButtonShadow};

  border-radius: 5rem;
  cursor: pointer;
  font-size: ${SwapStyle.normalText};
  justify-content: space-between;
  overflow: hidden;
  width: 110px;
  padding: 11px;
  outline: none;
  font-weight: bold;
  text-decoration: none;
  text-align: center;

  &:hover {
    color: ${( { theme }) => theme.poolPanelButtonColorHover};
    background-color: ${( { theme }) => theme.poolPanelButtonBackgroundColorHover};
    // border: 1px solid ${({ theme }) => theme.poolPanelButtonBorderColorHover};
  }
`

interface Props {
  onClick: VoidFunction
}
export const PoolButton: FC<Props> = ({ onClick, children }) => {
  return <_PoolButton onClick={onClick}>{children}</_PoolButton>
}
